import svgPaths from "./svg-wtysv5q4dn";
import imgSchermAfbeelding20240523Om10191 from "../assets/map-safari-popup.webp";
import imgSchermAfbeelding20230409Om20462 from "../assets/globe-light-blue.webp";

function StipplMap() {
	return (
		<div className="overflow-clip relative rounded-[8px] shrink-0 size-[120px]" data-name="stipplMap">
			<div className="absolute h-[162.439px] left-[-37.8px] top-[-21.95px] w-[197.801px]" data-name="Scherm­afbeelding 2024-05-23 om 10.19 1">
				<img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgSchermAfbeelding20240523Om10191} />
			</div>
			<div className="absolute h-[202.683px] left-[-6.59px] top-[-21.95px] w-[127.317px]" data-name="Scherm­afbeelding 2023-04-09 om 20.46 2">
				<div className="absolute inset-0 overflow-hidden pointer-events-none">
					<img alt="" className="absolute h-[124.26%] left-[-20.14%] max-w-none top-[-21.14%] w-[140.09%]" src={imgSchermAfbeelding20230409Om20462} />
				</div>
			</div>
		</div>
	);
}

function Frame1() {
	return (
		<div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
			<div className="overflow-clip relative shrink-0 size-[18px]" data-name="Check">
				<div className="absolute inset-[8.33%]" data-name="Vector">
					<svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15 15">
						<path d={svgPaths.p3b40cff0} fill="var(--fill-0, #13C892)" id="Vector" />
					</svg>
				</div>
				<div className="absolute inset-[34.55%_30.39%_31.61%_26.2%]" data-name="Vector">
					<svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 7.81425 6.09">
						<path d={svgPaths.p3a756460} fill="var(--fill-0, #13C892)" id="Vector" />
					</svg>
				</div>
			</div>
			<div className="flex flex-col font-['Poppins:SemiBold',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[#13c892] text-[12px] whitespace-nowrap">
				<p className="leading-[normal]">Stippl</p>
			</div>
		</div>
	);
}

export default function Frame() {
	return (
		<div className="content-stretch flex flex-col gap-[8px] items-start relative size-full">
			<StipplMap />
			<Frame1 />
		</div>
	);
}
